export default __webpack_public_path__ + "static/media/ILUSTRACIONES_10.3911973d.png";